import { render, staticRenderFns } from "./fuHeader.vue?vue&type=template&id=34b37f27&scoped=true"
import script from "./fuHeader.vue?vue&type=script&lang=js"
export * from "./fuHeader.vue?vue&type=script&lang=js"
import style0 from "./fuHeader.vue?vue&type=style&index=0&id=34b37f27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b37f27",
  null
  
)

export default component.exports